module.exports = __webpack_public_path__ + "593a3d53/img/note-list-icon.961c1485.svg";